import { render, staticRenderFns } from "./doublecode.vue?vue&type=template&id=3541a1ec&"
import script from "./doublecode.vue?vue&type=script&lang=js&"
export * from "./doublecode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports